import utils from 'utils'
import Vehicle from '../invoice1/model/Vehicle'

export default class VehicleInvAddCtrl {
    constructor($scope, $uibModal, logger, httpRequest, sweetalert, globalFn, $state, $timeout, invoiceOpenService, operationService, buyerChecker) {
        httpRequest.get_dictByTypeArr(['ovat_tax_rate', 'invoice_status']).then((res) => {
            $scope.dictData = res.data.value
        })
        // 已开具机动车详情
        if ($state.current.name.indexOf('openedInvoice.vehicleDetail') != -1) {
            $scope.isOpenRedInfo = true
        }
        $state.current.name.split('.').forEach(i => {
            if (i == 'workspace') $scope.haveBorder = true
            if (i == 'redInfoVehicle') $scope.isRedInfo = true
            if (i == 'cancelInvoice') $scope.isCancelReopenInv = true
        })
        if ($state.params.canceledInvoiceId) {
            $scope.canceledInvoiceId = $state.params.canceledInvoiceId
        }
        const _waitId = $state.params.waitId // 待开Id
        const _invoiceId = $state.params.invoiceId // 已开Id
        $scope.parentInvoiceId = $state.params.parentInvoiceId // 红冲父票id
        const vehicle = new Vehicle()
        $scope.openedInvFlag = !!_invoiceId
        $scope.param = vehicle.params
        $scope.blueInvCode = ''
        $scope.blueInvNo = ''
        $scope.pageState = $scope.pageState ? $scope.pageState : {}
        let quota = 0
        let {
            taxCode
        } = $scope.pageState
        let {
            CheckCode
        } = $scope.pageState
        let {
            machineNo
        } = $scope.pageState
        const _userInfo = JSON.parse(localStorage.user_info) ? JSON.parse(localStorage.user_info) : {}
        let taxDiskType
        let {
            kpfwqh
        } = $scope.pageState
        if (_userInfo.sale) {
            taxDiskType = _userInfo.sale.taxDiskType
        }
        // 如果是控制台则增加样式
        if ($state.current.name.indexOf('workspace') > -1) {
            $scope.haveBorder = true
        }

        function init() {
            // 详情页进入
            $scope.detailEnable = false
            // 提交按键使能
            // $scope.submitEnable = false
            // 红冲按键使能
            $scope.redVehicleInv = false
            // 税收分类编码版本号
            $scope.codeVersions = ''
            // 购方名称联动组件
            $scope.buyerInfo = {
                customerName: '',
                creditCode: '',
                certificateNo: '',
            }
            // 车辆信息联动组件
            $scope.carInfo = {
                vehicleType: '',
                brandmode: '',
                place: '',
                taxRate: '',
            }
            // $scope.taxRateArr = vehicle.taxRateArr

            switch ($state.current.name) {
                case 'outputManage.FOManage.vehicleInvoice.add':
                    $scope.detailEnable = false
                    $scope.redVehicleInv = false
                    break
                case 'outputManage.FOManage.vehicleInvoice.edit':
                    $scope.detailEnable = false
                    $scope.redVehicleInv = false
                    break
                case 'outputManage.FOManage.vehicleInvoice.detail':
                    $scope.detailEnable = true
                    $scope.redVehicleInv = false
                    break
                case 'outputManage.FOManage.vehicleInvoice.addred':
                    $scope.detailEnable = false
                    $scope.redVehicleInv = true
                    $scope.param.isRed = '1'
                    break
                case 'outputManage.FOManage.vehicleInvoice.editRed':
                    $scope.detailEnable = false
                    $scope.redVehicleInv = true
                    $scope.param.isRed = '1'
                    break
                case 'outputManage.FOManage.vehicleInvoice.detailRed':
                    $scope.detailEnable = true
                    $scope.redVehicleInv = true
                    break
                case 'workspace.item.vehicle':
                    $scope.detailEnable = true
                    $scope.redVehicleInv = false
                    break
                case 'outputManage.billManage.openedInvoice.vehicleDetail':
                    $scope.detailEnable = true
                    $scope.redVehicleInv = false
                    break
                case 'workspace.item.reopenVehicleApprove':
                    $scope.detailEnable = true
                    $scope.redVehicleInv = false
                    break
                case 'outputManage.billManage.cancelInvoice.vehiceDetail':
                    $scope.detailEnable = true
                    $scope.redVehicleInv = false
                    break
                case 'outputManage.billManage.openedInvoice.redInfoVehicle':
                    $scope.detailEnable = false
                    $scope.redVehicleInv = true
                    break
                case 'outputManage.FOManage.ovatBill.relatedVehicleDetail':
                    $scope.detailEnable = true
                    $scope.redVehicleInv = false
                    break
            }
            // 税率默认
            // $scope.param.taxRate = $scope.taxRateArr[0]['taxRate']
            // 大写价税合计
            $scope.adValoremTotalUpper = globalFn.digitUppercase(+$scope.param.adValoremTotal)
            // 获取待开编号和创建时间
            invoiceOpenService.getGetBeanIdDkfp().then((res) => {
                if (res.data.success) {
                    const _resArr = res.data.value.split(',')
                    $scope.param.waitId = _resArr[0]
                    $scope.createTime = _resArr[1]
                }
            })
            //  获取机动车开票税收分类默认版本号
            // invoiceOpenService.getQryVehicleTaxClass({
            //     accessToken: localStorage.getItem('id_token')
            // }).then((res) => {
            //     if (res.data.success) {
            //         $scope.codeVersions = res.data.value
            //     }
            // })
            // 开票点
            $scope.ukeyList = JSON.parse(localStorage.user_info) && JSON.parse(localStorage.user_info).sysUkeyList
            if ($scope.ukeyList && $scope.ukeyList.length > 0) {
                vehicle.$setUkeyDiskInfo = $scope.ukeyList[0]
                invoiceOpenService.getTaxDiskInfo($scope.param.ukeyId).then((res) => {
                    quota = res.vehicleQuota
                    // 金税盘机器号
                    $scope.param.diskNo = res.diskNo
                })
            }

            $scope.openInvTime = new Date()

            // 银行列表
            invoiceOpenService.postBankBySale().then((res) => {
                if (res.data.success) {
                    $scope.saleBanks = res.data.value.filter((val) => val.status === 1)
                }
            })
        }
        init()
        // 隐藏一二级菜单
        if ($scope.detailEnable) {
            $('#wrapper').addClass('invoiceDetailPage')
            $scope.$on('$stateChangeStart', () => {
                $('#wrapper').removeClass('invoiceDetailPage')
            })
        }
        // 库存查询
        invoiceOpenService.getStockByUkey($scope.ukeyList, $scope.param.ukeyId, $scope.param.invType).then((obj) => {
            $scope.hintMsg = `剩余发票数量: ${obj.sum}`
        }, (error) => {
            $scope.hintMsg = error
        })
        // 如果分别从已开/待开 编辑/详情页进入
        if (_waitId || _invoiceId || $scope.parentInvoiceId || $scope.isCancelReopenInv) {
            $timeout(() => {
                let resData
                // 页面数据修正函数
                const resDataSet = function (resData) {
                    $scope.detailPageTaxRate = resData.taxRate
                    if (resData.taxRate == '-0.01' || resData.taxRate == '-0.02') {
                        resData.taxRate = '0'
                    }
                    $scope.param = $.extend({}, $scope.param, resData)
                    if ($scope.isRedInfo) { // 已开红冲清空billcode
                        $scope.param.billCode = ''
                    }
                    // 如返回价税合计为负，则做红冲发票处理
                    // if (+$scope.param.adValoremTotal < 0) {
                    //     $scope.redVehicleInv = true
                    // }
                    // 小写价税合计
                    $scope.param.adValoremTotal = (+$scope.param.adValoremTotal).toFixed(2)
                    // 开票点数据
                    $scope.ukeyList = JSON.parse(localStorage.user_info) && JSON.parse(localStorage.user_info).sysUkeyList
                    if ($scope.ukeyList && $scope.ukeyList.length > 0) {
                        $scope.ukeyList.forEach((item) => {
                            if (item.ukeyId === $scope.param.ukeyId) {
                                $scope.param.ukeyName = item.ukeyName
                            }
                        })
                    }
                    // 限额 盘号
                    invoiceOpenService.getTaxDiskInfo($scope.param.ukeyId).then((res) => {
                        quota = res.vehicleQuota
                        // 金税盘机器号
                        $scope.param.diskNo = res.diskNo
                    })
                    // 大写
                    $scope.adValoremTotalUpper = globalFn.digitUppercase(+$scope.param.adValoremTotal)
                    // 税率
                    $scope.carInfo.taxRate = +resData.taxRate
                    // 购方名称
                    $scope.buyerInfo.customerName = resData.custName
                    // 购方企业类型
                    $scope.buyerInfo.taxplayerType = resData.creditType
                    // 购方纳税人信用代码
                    $scope.buyerInfo.creditCode = resData.custCreditCode
                    // 购方身份证/组织机构代码
                    $scope.buyerInfo.certificateNo = resData.custIdentifyNo
                    // 税额计算
                    $scope.param.totalAmt = (+$scope.param.adValoremTotal / (+$scope.param.taxRate + 1)).toFixed(2)
                    $scope.param.totalTaxamt = ($scope.param.adValoremTotal - $scope.param.totalAmt).toFixed(2)
                }
                // 已开 待开 返字段不一样
                // 待开  获取数据
                if (_waitId) {
                    httpRequest.get_queryOvatInvoiceWait({
                        waitId: _waitId,
                    }).then((res) => {
                        resData = res.data.value
                        if (resData.blueInvoiceCode && resData.blueInvoiceNumber) {
                            $scope.blueFlag = true
                        }
                        const detail = resData.waitDetailList[0]
                        const carInfo = {
                            codeVersions: detail.revenueVersion, // 编码版本号
                            vehicleType: resData.vehicleInvoice.vehicleType, // 车辆类型
                            brandmode: resData.vehicleInvoice.factoryModel, // 厂牌型号
                            place: resData.vehicleInvoice.placeOfOrigin, // 产地
                            enterpriseName: resData.vehicleInvoice.manufacturer, // 生产企业名称
                            isPrivilege: detail.isPrivilege, // 是否享受优惠政策
                            privilegeType: detail.privilegeType, // 优惠政策类型
                            taxMergeCode: detail.revenueCode, // 税分编码
                            taxClassName: detail.revenueName, // 税分编码名称
                        }

                        $scope.carInfo = carInfo
                        // 税率备选下拉框
                        // $scope.taxRateArr = resData.waitDetailList[0]['taxRateArr']
                        resDataSet(resData)
                        // 审批详情样式修改
                        if ($state.current.name == 'workspace.item.vehicle') {
                            $('.textIpt').css('border-right', 'none')
                        }
                    })
                }

                // 已开 获取数据
                if (_invoiceId) {
                    httpRequest.post_getOvatInvoice(_invoiceId).then((res) => {
                        resData = res.data.value
                        // 编码版本号
                        $scope.carInfo.codeVersions = resData.invoiceDetailList[0].revenueVersion
                        $scope.param.vehicleInvoice = $.extend({}, $scope.param.vehicleInvoice, resData.ovatInvoiceVehicleDTO)
                        // 车辆类型
                        $scope.carInfo.vehicleType = resData.ovatInvoiceVehicleDTO.vehicleType
                        // 厂牌型号
                        $scope.carInfo.brandmode = resData.ovatInvoiceVehicleDTO.factoryModel
                        // 产地
                        $scope.carInfo.place = resData.ovatInvoiceVehicleDTO.placeOfOrigin
                        // 生产企业名称
                        $scope.carInfo.enterpriseName = resData.ovatInvoiceVehicleDTO.manufacturer
                        // 是否享受优惠政策
                        $scope.carInfo.isPrivilege = resData.invoiceDetailList[0].isPrivilege
                        // 优惠政策类型
                        $scope.carInfo.privilegeType = resData.invoiceDetailList[0].privilegeType
                        // 税分编码
                        $scope.carInfo.taxMergeCode = resData.invoiceDetailList[0].revenueCode
                        // 税分编码名称
                        $scope.carInfo.taxClassName = resData.invoiceDetailList[0].revenueName
                        // 税率
                        $scope.carInfo.taxRate = +resData.taxRate
                        // 税率备选下拉框
                        // $scope.taxRateArr = $scope.carInfo.isPrivilege == 1 ? [{ taxText: '免税', taxRate: 0 }] : [{ taxText: resData.taxRate * 100 + '%', taxRate: +resData.taxRate }]
                        $scope.mainSale = `${resData.ovatInvoiceVehicleDTO.mainSaleName}  ${resData.ovatInvoiceVehicleDTO.mainSaleCode}`

                        $scope.openedInvCode = resData.invoiceCode
                        $scope.openedInvNumber = resData.invoiceNumber
                        $('.tabTop_copyBtn').hide()
                        resDataSet(resData)
                        // 审批详情样式修改
                        if ($state.current.name == 'workspace.item.reopenVehicleApprove') {
                            $('.textIpt').css('border-right', 'none')
                        }
                    })
                }
                if ($scope.parentInvoiceId) {
                    httpRequest.post_getOvatInvoice($scope.parentInvoiceId).then((res) => {
                        makeRedFromBlue(res.data.value)
                    })
                }
                if ($scope.canceledInvoiceId) {
                    httpRequest.post_getOvatInvoice($scope.canceledInvoiceId).then((res) => {
                        const blue = res.data.value
                        setCopyInvoice(blue)
                        if (blue.isRed == '1') {
                            $scope.blueFlag = false
                            $scope.redVehicleInv = true
                            $scope.param.isRed = '1'
                            $scope.param.blueInvoiceCode = blue.blueInvoiceCode
                            $scope.param.blueInvoiceNumber = blue.blueInvoiceNumber
                            $scope.param.adValoremTotal = blue.adValoremTotal.toFixed(2)
                            $scope.adValoremTotalUpper = globalFn.digitUppercase(+$scope.param.adValoremTotal)
                            $scope.param.totalAmt = (+$scope.param.adValoremTotal / (+$scope.param.taxRate + 1)).toFixed(2)
                            $scope.param.totalTaxamt = ($scope.param.adValoremTotal - $scope.param.totalAmt).toFixed(2)
                        }
                        $scope.param.billCode = blue.billCode
                        $scope.param.invoiceSource = blue.invoiceSource
                    })
                }
                if ($scope.detailEnable) {
                    $('.ibox-content input').attr('readonly', 'readonly')
                    $('.ibox-content select').attr('disabled', 'disabled')
                }
            })
        }

        // 账号变更联动开户银行
        $scope.bankAccountChange = function saleBankChange() {
            $scope.saleBanks.forEach((val) => {
                $scope.param.saleBank = (val.bankAccount === $scope.param.saleBankAccount ? val.bank : $scope.param.saleBank)
            })
        }

        // 获取ukeyCode
        $scope.changerUkeyId = function () {
            const _ukeyList = $scope.ukeyList
            const ukeyLen = _ukeyList.length
            if (ukeyLen > 0) {
                for (let i = 0; i < ukeyLen; i++) {
                    if (_ukeyList[i].ukeyId === $scope.param.ukeyId) {
                        vehicle.$setUkeyDiskInfo = $scope.ukeyList[i]
                        httpRequest.get_getTaxDisk($scope.param.ukeyId).then((res) => {
                            const _data = res.data
                            if (!_data.success) {
                                return
                            }
                            quota = _data.value.vehicleQuota
                            // 金税盘机器号
                            $scope.param.diskNo = _data.value.diskNo
                        })
                        break
                    }
                }
            }
            invoiceOpenService.getStockByUkey($scope.ukeyList, $scope.param.ukeyId, $scope.param.invType).then((obj) => {
                $scope.hintMsg = `剩余发票数量: ${obj.sum}`
            }, (error) => {
                $scope.hintMsg = error
            })
        }

        // 暂存
        $scope.scratch = function scratch() {
            if (vehicle.basicCheck($scope, quota)) {
                logger.logError(vehicle.basicCheck($scope, quota))
                return
            }
            let _creditType = $scope.param.creditType,
                _custCreditCode = $scope.param.custCreditCode
            if (_creditType == 1 && (!globalFn.checkTax(_custCreditCode, 1) ||
                    _custCreditCode.length > 20) && _custCreditCode) {
                logger.logError("购方信用代码必须是6~20位大写字母或数字");
                return false;
            }
            if ($scope.param.isRed == '1') {
                $scope.param.remark = `对应正数发票代码:${$scope.param.blueInvoiceCode}号码:${$scope.param.blueInvoiceNumber}`
            }
            invoiceOpenService.scratch($scope.param).then((res) => {
                if (!res.data.success) {
                    logger.logError(res.data.message)
                    return
                }
                logger.logSuccess('暂存成功')
            })
        }

        function check(invoice, callback, printFlag) {
            const userInfo = JSON.parse(localStorage.getItem('user_info'))
            if (userInfo.org.invoiceFlag !== 1) {
                logger.logError('您所在机构禁止开票，请联系管理员启用')
                return
            }
            if (userInfo.sale.taxplayerType === '3' ||
                userInfo.sale.taxplayerType === '4' ||
                userInfo.sale.taxplayerType === '9') {
                logger.logError('您所在企业纳税人类型不具备开票资格')
                return
            }
            if (!operationService.hasPermit('open_invoice_v')) {
                return
            }
            if (invoice.description && (invoice.description.slice(0, 4) == '4003' || invoice.description.slice(0, 4) == '4005')) {
                sweetalert.confirm('操作提醒', '发票上次写库失败，请先到开票软件进行发票修复后，再点击确认。避免重复开具该发票，造成跳号错觉').then(() => {
                    if (invoice.checker && invoice.payee && invoice.checker.trim() === invoice.payee.trim()) {
                        sweetalert.confirm(
                            '操作提醒',
                            '收款人和复核人为同一个人，可能影响发票的认可度，确定开票吗？',
                        ).then(() => {
                            callback(printFlag)
                        })
                    } else {
                        callback(printFlag)
                    }
                })
            } else if (invoice.checker && invoice.payee && invoice.checker.trim() === invoice.payee.trim()) {
                sweetalert.confirm(
                    '操作提醒',
                    '收款人和复核人为同一个人，可能影响发票的认可度，确定开票吗？',
                ).then(() => {
                    callback(printFlag)
                })
            } else {
                callback(printFlag)
            }
        }
        $scope.openRedInv = function openRedInv() {
            if (vehicle.basicCheck($scope, quota)) {
                logger.logError(vehicle.basicCheck($scope, quota))
                return
            }
            let _creditType = $scope.param.creditType,
                _custCreditCode = $scope.param.custCreditCode
            if (_creditType == 1 && (!globalFn.checkTax(_custCreditCode, 1) ||
                    _custCreditCode.length > 20) && _custCreditCode) {
                logger.logError("购方信用代码必须是6~20位大写字母或数字");
                return false;
            }
            if ($scope.isCancelReopenInv) { //发票重开
                $scope.param.originalInvoiceId = $scope.canceledInvoiceId
                utils.loading('正在保存，请稍候')
                if ($scope.param.isRed === '1') {
                    $scope.param.remark = `对应正数发票代码:${$scope.param.blueInvoiceCode}号码:${$scope.param.blueInvoiceNumber}`
                    httpRequest.post_checkOvatInvoiceList({
                        invoiceCode: $scope.param.blueInvoiceCode,
                        invoiceNumber: $scope.param.blueInvoiceNumber,
                        invoiceType: 12,
                    }).then((res) => {
                        if (res.data.value) {
                            invoiceOpenService.reopenInvoiceWait($scope.param).then((res) => {
                                utils.loaded()
                                const invoiceDTO = $scope.param
                                check(invoiceDTO, openInvoice, false)
                            })
                        } else {
                            utils.loaded()
                            sweetalert.confirm('操作提醒', '本地没有找到对应蓝票，是否要提交？').then(() => {
                                invoiceOpenService.reopenInvoiceWait($scope.param).then((res) => {
                                    const invoiceDTO = $scope.param
                                    check(invoiceDTO, openInvoice, false)
                                })
                            })
                        }
                    }, (error) => {
                        utils.loaded()
                        logger.logError(error)
                    })
                } else {
                    invoiceOpenService.reopenInvoiceWait($scope.param).then((res) => {
                        utils.loaded()
                        const invoiceDTO = $scope.param
                        check(invoiceDTO, openInvoice, false)
                    }, (error) => {
                        utils.loaded()
                    })
                }
            } else {
                utils.loading('正在保存，请稍候')
                $scope.param.isRed === '1'
                $scope.param.remark = `对应正数发票代码:${$scope.param.blueInvoiceCode}号码:${$scope.param.blueInvoiceNumber}`
                httpRequest.post_reddingInvoice($scope.param).then((res) => {
                    if (res.data.success && res.data.value) {
                        const waitInvoice = res.data.value
                        $scope.param = waitInvoice
                        httpRequest.post_lockOvatInvoice({
                            invoiceIds: [$scope.parentInvoiceId],
                            isLock: '1'
                        }).then(() => { // 锁票
                            utils.loaded()
                            if (waitInvoice.waitInvoiceStatus === '2') {
                                check(waitInvoice, openInvoice, false)
                            } else {
                                $scope.goListPage()
                            }
                        }).finally(() => {
                            httpRequest.post_lockOvatInvoice({
                                invoiceIds: [$scope.parentInvoiceId],
                                isLock: '0'
                            }) // 释放票
                        })
                    }
                }, (error) => {
                    utils.loaded()
                    logger.logError(error)
                })
            }
        }
        $scope.openRedInvAndPrint = function openRedInvAndPrint() {
            if (vehicle.basicCheck($scope, quota)) {
                logger.logError(vehicle.basicCheck($scope, quota))
                return
            }

            let _creditType = $scope.param.creditType,
                _custCreditCode = $scope.param.custCreditCode
            if (_creditType == 1 && (!globalFn.checkTax(_custCreditCode, 1) ||
                    _custCreditCode.length > 20) && _custCreditCode) {
                logger.logError("购方信用代码必须是6~20位大写字母或数字");
                return false;
            }
            if ($scope.isCancelReopenInv) { //发票重开
                $scope.param.originalInvoiceId = $scope.canceledInvoiceId
                utils.loading('正在保存，请稍候')
                if ($scope.param.isRed === '1') {
                    $scope.param.remark = `对应正数发票代码:${$scope.param.blueInvoiceCode}号码:${$scope.param.blueInvoiceNumber}`
                    httpRequest.post_checkOvatInvoiceList({
                        invoiceCode: $scope.param.blueInvoiceCode,
                        invoiceNumber: $scope.param.blueInvoiceNumber,
                        invoiceType: 12,
                    }).then((res) => {
                        if (res.data.value) {
                            invoiceOpenService.reopenInvoiceWait($scope.param).then((res) => {
                                utils.loaded()
                                const invoiceDTO = $scope.param
                                check(invoiceDTO, openInvoice, true)
                            })
                        } else {
                            utils.loaded()
                            sweetalert.confirm('操作提醒', '本地没有找到对应蓝票，是否要提交？').then(() => {
                                invoiceOpenService.reopenInvoiceWait($scope.param).then((res) => {
                                    const invoiceDTO = $scope.param
                                    check(invoiceDTO, openInvoice, true)
                                })
                            })
                        }
                    }, (error) => {
                        utils.loaded()
                        logger.logError(error)
                    })
                } else {
                    invoiceOpenService.reopenInvoiceWait($scope.param).then((res) => {
                        utils.loaded()
                        const invoiceDTO = $scope.param
                        check(invoiceDTO, openInvoice, true)
                    }, (error) => {
                        utils.loaded()
                    })
                }
            } else {
                utils.loading('正在保存，请稍候')
                $scope.param.isRed === '1'
                $scope.param.remark = `对应正数发票代码:${$scope.param.blueInvoiceCode}号码:${$scope.param.blueInvoiceNumber}`
                httpRequest.post_reddingInvoice($scope.param).then((res) => {
                    if (res.data.success && res.data.value) {
                        const waitInvoice = res.data.value
                        httpRequest.post_lockOvatInvoice({
                            invoiceIds: [$scope.parentInvoiceId],
                            isLock: '1'
                        }).then(() => { // 锁票
                            utils.loaded()
                            if (waitInvoice.waitInvoiceStatus === '2') {
                                check(waitInvoice, openInvoice, true)
                            } else {
                                $scope.goListPage()
                            }
                        }).finally(() => {
                            httpRequest.post_lockOvatInvoice({
                                invoiceIds: [$scope.parentInvoiceId],
                                isLock: '0'
                            }) // 释放票
                        })
                    }
                }, (error) => {
                    utils.loaded()
                    logger.logError(error)
                })
            }
        }
        $scope.goListPage = function goListPage() {
            if ($scope.isRedInfo) {
                $state.go('outputManage.billManage.openedInvoice.list')
            } else if ($scope.isCancelReopenInv) {
                $state.go('outputManage.billManage.cancelInvoice.list')
            } else {
                $state.go('outputManage.FOManage.vehicleInvoice.list')
            }
        }
        // 提交
        function doSubmit() {
            if ($scope.param.isRed == '1') {
                $scope.param.remark = `对应正数发票代码:${$scope.param.blueInvoiceCode}号码:${$scope.param.blueInvoiceNumber}`
            }
            invoiceOpenService.scratchAndSubmit($scope.param).then((res) => {
                const invoiceDTO = $scope.param
                if (res.data.value.waitInvoiceStatus === '2') {
                    window.layer.open({
                        title: '操作提醒',
                        content: '提交成功,是否继续开票，您也可以稍后在列表页面开票',
                        btn: ['开票', '取消', '开票打印'],
                        yes(index) {
                            window.layer.close(index)
                            check(invoiceDTO, openInvoice, false)
                        },
                        btn2(index) {
                            window.layer.close(index)
                            $state.go('outputManage.FOManage.vehicleInvoice.list')
                        },
                        btn3(index) {
                            window.layer.close(index)
                            check(invoiceDTO, openInvoice, true)
                        },
                        cancel(index) {
                            window.layer.close(index)
                            $state.go('outputManage.FOManage.vehicleInvoice.list')
                        },
                    })
                } else {
                    logger.logSuccess('提交成功')
                    $state.go('outputManage.FOManage.vehicleInvoice.list')
                }
            })
        }
        $scope.submit = function submit() {
            if (vehicle.basicCheck($scope, quota)) {
                logger.logError(vehicle.basicCheck($scope, quota))
                return
            }
            let _creditType = $scope.param.creditType,
                _custCreditCode = $scope.param.custCreditCode
            if (_creditType == 1 && (!globalFn.checkTax(_custCreditCode, 1) ||
                    _custCreditCode.length > 20) && _custCreditCode) {
                logger.logError("购方信用代码必须是6~20位大写字母或数字");
                return false;
            }
            if ($scope.param.isRed === '1') {
                $scope.param.remark = `对应正数发票代码:${$scope.param.blueInvoiceCode}号码:${$scope.param.blueInvoiceNumber}`
                httpRequest.post_checkOvatInvoiceList({
                    invoiceCode: $scope.param.blueInvoiceCode,
                    invoiceNumber: $scope.param.blueInvoiceNumber,
                    invoiceType: 12,
                }).then((res) => {
                    if (res.data.value) {
                        doSubmit()
                    } else {
                        sweetalert.confirm('操作提醒', '本地没有找到对应蓝票，是否要提交？').then(() => {
                            doSubmit()
                        })
                    }
                })
            } else {
                doSubmit()
            }
        }

        function setCopyInvoice(item) {
            if (item.taxRate == '-0.01' || item.taxRate == '-0.02') {
                item.taxRate = '0'
            }
            $scope.selectedRows = []
            $scope.param.hardwareNo = item.hardwareNo
            // 销方信息
            $scope.param.saleAddress = item.saleAddress
            $scope.param.salePhone = item.salePhone
            $scope.param.saleBank = item.saleBank
            $scope.param.saleBankAccount = item.saleBankAccount
            $scope.param.saleCreditCode = item.saleCreditCode
            $scope.param.saleId = item.saleId
            $scope.param.saleName = item.saleName
            // 购方信息
            $scope.param.custAddress = item.custAddress
            $scope.param.custBank = item.custBank
            $scope.param.custCode = item.custCode
            $scope.param.custBankAccount = item.custBankAccount
            $scope.param.custCreditCode = item.custCreditCode
            $scope.param.custMobile = item.custMobile
            $scope.param.custName = item.custName
            $scope.param.custPhone = item.custPhone

            // 机动车发票
            $scope.buyerInfo.customerName = item.custName
            $scope.buyerInfo.taxplayerType = item.creditType
            $scope.buyerInfo.creditCode = item.custCreditCode
            $scope.buyerInfo.certificateNo = item.custIdentifyNo

            $scope.param.adValoremTotal = (+item.adValoremTotal).toFixed(2)
            $scope.adValoremTotalUpper = globalFn.digitUppercase(+$scope.param.adValoremTotal)
            $scope.param.totalAmt = (+$scope.param.adValoremTotal / (+$scope.param.taxRate + 1)).toFixed(2)
            $scope.param.totalTaxamt = ($scope.param.adValoremTotal - $scope.param.totalAmt).toFixed(2)
            // 已开和待开发票返回值字段不一样（而且是2个字段的值都不一样）
            const vehicleReturnData = item.ovatInvoiceVehicleDTO ? 'ovatInvoiceVehicleDTO' : 'vehicleInvoice'
            const detailReturnData = item.waitDetailList ? item.waitDetailList[0] : item.invoiceDetailList[0]
            $scope.carInfo.vehicleType = item[vehicleReturnData].vehicleType
            $scope.carInfo.brandmode = item[vehicleReturnData].factoryModel
            $scope.carInfo.place = item[vehicleReturnData].placeOfOrigin
            $scope.carInfo.enterpriseName = item[vehicleReturnData].manufacturer
            $scope.carInfo.codeVersions = detailReturnData.revenueVersion
            $scope.carInfo.taxRate = +item.taxRate
            // 是否享受优惠政策
            $scope.carInfo.isPrivilege = detailReturnData.isPrivilege
            // 优惠政策类型
            $scope.carInfo.privilegeType = detailReturnData.privilegeType
            // 税分编码
            $scope.carInfo.taxMergeCode = detailReturnData.revenueCode
            // 税分编码名称
            $scope.carInfo.taxClassName = detailReturnData.revenueName

            $scope.param.vehicleInvoice.certificateNumber = item[vehicleReturnData].certificateNumber
            $scope.param.vehicleInvoice.importIdNumber = item[vehicleReturnData].importIdNumber
            $scope.param.vehicleInvoice.checkNumber = item[vehicleReturnData].checkNumber
            $scope.param.vehicleInvoice.engineNumber = item[vehicleReturnData].engineNumber
            $scope.param.vehicleInvoice.vehicleNumber = item[vehicleReturnData].vehicleNumber
            $scope.param.vehicleInvoice.tonnage = item[vehicleReturnData].tonnage
            $scope.param.vehicleInvoice.limitPeople = item[vehicleReturnData].limitPeople
        }

        // 复制
        $scope.copyInvoice = function () {
            const req = {
                pageNum: 1,
                pageSize: 5,
                orderMap: {
                    invoiceDate: 'desc'
                },
                param: {
                    invType: $scope.param.invType,
                    waitId: '',
                    isRed: '0',
                    invoiceDateBegin: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-1`,
                    invoiceDateEnd: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,
                    taxRate: '',
                },
            }
            httpRequest.post_qryOvatInvoiceCopyList(req).then((res) => {
                const resData = res.data.value.list
                // 获取后台分页数据 回写分页组件
                // if (resData.length == 0) {
                //     logger.logError('暂无蓝票')
                //     return
                // }
                const copyInvoiceData = {}
                copyInvoiceData.list = resData
                copyInvoiceData.totalItems = res.data.value.total
                copyInvoiceData.currentPage = ++res.data.value.prePage
                copyInvoiceData.maxSize = res.data.value.pageSize
                copyInvoiceData.currentOrgId = JSON.parse(localStorage.user_info).user.currentOrgId
                copyInvoiceData.invType = $scope.param.invType
                const modalInstance = $uibModal.open({
                    templateUrl: 'copyInvoiceModalContent.html',
                    controller: 'modalCopyInvoiceCtrl',
                    openedClass: 'mod-modal-haslist blue-invoice-list mod-modal mod-modal-so-hg',
                    backdrop: 'static',
                    resolve: {
                        items1() {
                            return copyInvoiceData
                        },
                    },
                })
                modalInstance.result.then((item) => {
                    setCopyInvoice(item)
                }, () => {
                    console.log(`Modal dismissed at: ${new Date()}`)
                })
            })
        }

        // loading索引
        let opening

        function getBlueList(invoiceCode, invoiceNumber) {
            const req = {
                pageNum: 1,
                pageSize: 5,
                param: {
                    invType: $scope.param.invType,
                    invoiceCode,
                    invoiceNumber,
                    isCancel: '0',
                    isRed: '1',
                },
            }

            return httpRequest.post_getNormalBlueInvoice(req)
        }

        // 蓝票对象复制成红票对象
        function makeRedFromBlue(blue) {
            if (blue.taxRate == '-0.01' || blue.taxRate == '-0.02') {
                blue.taxRate = '0'
            }
            $scope.blueFlag = true
            $scope.selectedRows = []
            $scope.param.billCode = blue.billCode
            $scope.param.hardwareNo = blue.hardwareNo
            // 销方信息
            $scope.param.saleAddress = blue.saleAddress
            $scope.param.salePhone = blue.salePhone
            $scope.param.saleBank = blue.saleBank
            $scope.param.saleBankAccount = blue.saleBankAccount
            $scope.param.saleCreditCode = blue.saleCreditCode
            $scope.param.saleId = blue.saleId
            $scope.param.saleName = blue.saleName
            // 购方信息
            $scope.param.custAddress = blue.custAddress
            $scope.param.custBank = blue.custBank
            $scope.param.custCode = blue.custCode
            $scope.param.custBankAccount = blue.custBankAccount
            $scope.param.custCreditCode = blue.custCreditCode
            $scope.param.custMobile = blue.custMobile
            $scope.param.custName = blue.custName
            $scope.param.custPhone = blue.custPhone

            // 机动车发票
            $scope.buyerInfo.customerName = blue.custName
            $scope.buyerInfo.taxplayerType = blue.creditType
            $scope.buyerInfo.creditCode = blue.custCreditCode
            $scope.buyerInfo.certificateNo = blue.custIdentifyNo

            $scope.param.adValoremTotal = (-(+blue.adValoremTotal)).toFixed(2)
            $scope.adValoremTotalUpper = globalFn.digitUppercase(+$scope.param.adValoremTotal)
            $scope.param.totalAmt = (+$scope.param.adValoremTotal / (+$scope.param.taxRate + 1)).toFixed(2)
            $scope.param.totalTaxamt = ($scope.param.adValoremTotal - $scope.param.totalAmt).toFixed(2)
            const blueCarInfo = blue.ovatInvoiceVehicleDTO
            $scope.param.blueInvoiceCode = blue.invoiceCode
            $scope.param.blueInvoiceNumber = blue.invoiceNumber
            if (!blueCarInfo) {
                logger.logError('获取蓝票车辆信息失败')
                return
            }
            const blueDetail = blue.invoiceDetailList[0]
            const carInfo = {
                vehicleType: blueCarInfo.vehicleType,
                brandmode: blueCarInfo.factoryModel,
                place: blueCarInfo.placeOfOrigin,
                enterpriseName: blueCarInfo.manufacturer,
                codeVersions: blueDetail.revenueVersion,
                taxRate: +blue.taxRate,
                isPrivilege: blueDetail.isPrivilege,
                privilegeType: blueDetail.privilegeType,
                taxMergeCode: blueDetail.revenueCode, // 税分编码
                taxClassName: blueDetail.revenueName, // 税分编码名称
            }
            $scope.carInfo = carInfo
            $scope.param.vehicleInvoice.certificateNumber = blue.ovatInvoiceVehicleDTO.certificateNumber
            $scope.param.vehicleInvoice.importIdNumber = blue.ovatInvoiceVehicleDTO.importIdNumber
            $scope.param.vehicleInvoice.checkNumber = blue.ovatInvoiceVehicleDTO.checkNumber
            $scope.param.vehicleInvoice.engineNumber = blue.ovatInvoiceVehicleDTO.engineNumber
            $scope.param.vehicleInvoice.vehicleNumber = blue.ovatInvoiceVehicleDTO.vehicleNumber
            $scope.param.vehicleInvoice.tonnage = blue.ovatInvoiceVehicleDTO.tonnage
            $scope.param.vehicleInvoice.limitPeople = blue.ovatInvoiceVehicleDTO.limitPeople
            // $scope.detailEnable = true
        }
        // 用户手动输入蓝票代码号码
        $scope.blueChange = function blueChange() {
            const {
                blueInvoiceCode
            } = $scope.param
            const {
                blueInvoiceNumber
            } = $scope.param
            if (blueInvoiceCode && blueInvoiceNumber) {
                getBlueList(blueInvoiceCode, blueInvoiceNumber).then((res) => {
                    const blueList = res.data.value.list
                    if (blueList.length === 1) {
                        const blueInvoice = blueList[0]
                        httpRequest.post_getOvatInvoice(blueInvoice.invoiceId).then((res) => {
                            makeRedFromBlue(res.data.value)
                        })
                    } else {
                        $scope.blueFlag = false
                        $scope.detailEnable = false
                    }
                })
            }
        }

        // 查找蓝票
        $scope.findInvoice = function () {
            const req = {
                pageNum: 1,
                pageSize: 5,
                orderMap: {
                    createTime: 'desc'
                },
                param: {
                    invType: $scope.param.invType,
                    isCancel: '0',
                    isRed: '1',
                    invoiceDateBegin: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-1`,
                    invoiceDateEnd: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,
                    taxRate: '',
                },
            }

            httpRequest.post_getNormalBlueInvoice(req).then((res) => {
                const resData = res.data.value.list
                // 获取后台分页数据 回写分页组件
                // if (resData.length == 0) {
                //     logger.logError('暂无可复制的蓝票')
                //     return
                // }
                const copyInvoiceData = {}
                copyInvoiceData.list = resData
                copyInvoiceData.totalItems = res.data.value.total
                copyInvoiceData.currentPage = ++res.data.value.prePage
                copyInvoiceData.maxSize = res.data.value.pageSize
                copyInvoiceData.invType = $scope.param.invType

                // // 蓝票代码
                // copyInvoiceData.blueInvCode = $scope.blueInvCode
                // // 蓝票号码
                // copyInvoiceData.blueInvNo = $scope.blueInvNo
                const modalInstance = $uibModal.open({
                    templateUrl: 'findInvoiceModalContent.html',
                    controller: 'modalFindBlueInvoiceCtrl',
                    openedClass: 'mod-modal-haslist blue-invoice-list mod-modal mod-modal-too-hg',
                    backdrop: 'static',
                    resolve: {
                        items1() {
                            return copyInvoiceData
                        },
                    },
                })
                modalInstance.result.then((item) => {
                    makeRedFromBlue(item)
                }, () => {
                    console.log(`Modal dismissed at: ${new Date()}`)
                })
            })
        }

        // 开票和开票打印
        function openInvoice(dyflag) {
            if (vehicle.basicCheck($scope, quota)) {
                logger.logError(vehicle.basicCheck($scope, quota))
                return
            }
            if ($scope.param.isRed == '1') {
                $scope.param.remark = `对应正数发票代码:${$scope.param.blueInvoiceCode}号码:${$scope.param.blueInvoiceNumber}`
            }
            invoiceOpenService.checkWithDiskInfo([$scope.param]).then((diskInfo) => {
                // 开票校验读取实时盘信息回写
                opening = layer.msg('开票初始化...', {
                    time: 0,
                    skin: 'layer-loading-self',
                    icon: 16,
                    shade: 0.5,
                })
                // 无key
                if (!!diskInfo === diskInfo) {
                    const dyPromise = dyflag ? invoiceOpenService.openPrint($scope.param) : invoiceOpenService.open($scope.param)
                    dyPromise.then((res) => {
                        $state.go('outputManage.FOManage.vehicleInvoice.list')
                    }).catch((err) => {
                        layer.close(opening)
                        logger.logError(err)
                    })
                } else {
                    Object.assign($scope.pageState, diskInfo)
                    taxCode = $scope.pageState.taxCode
                    CheckCode = $scope.pageState.CheckCode
                    machineNo = $scope.pageState.machineNo
                    kpfwqh = $scope.pageState.kpfwqh
                    if (taxCode === '' || taxCode === undefined || taxCode === null) {
                        logger.logError('读取金税盘失败,为了不影响您的开票操作，确保金税盘启用后，重新刷新页面!')
                        return
                    }
                    if (!dyflag) {
                        // 开票不打印
                        opening = window.layer.msg('请您耐心等待···正在开具发票；发票种类机动车发票', {
                            time: 0,
                            skin: 'layer-loading-self',
                            icon: 16,
                            shade: 0.5,
                        })
                        invoiceOpenService.open($scope.param).then((res) => {
                            layer.close(opening)
                            logger.logSuccess('开票成功')
                            $scope.isCancelReopenInv && cancelRewrite(0)
                            $scope.goListPage()
                        }, (err) => {
                            $scope.isCancelReopenInv && cancelRewrite(1)
                            // 会写失败原因
                            // httpRequest.post_writeOvatInvoiceFailReason({
                            //     reason: err.retmsg,
                            //     waitId: $scope.param.waitId,
                            // }).then(() => {
                            //     $scope.param.isLock = '0'
                            // })
                            $scope.isRedInfo && httpRequest.post_reddingFailedBackWrite([$scope.param.waitId])
                            layer.close(opening)
                            logger.logError(err.retmsg)
                            // if (err.retcode == 5012) {
                            // $state.go('outputManage.FOManage.vehicleInvoice.list')
                            $scope.goListPage()
                            // }
                        })
                    } else {
                        // 开票打印
                        opening = window.layer.msg('请您耐心等待···<br/>正在开具打印发票；<br/>发票种类机动车发票', {
                            time: 0,
                            skin: 'layer-loading-self',
                            icon: 16,
                            shade: 0.5,
                        })
                        invoiceOpenService.openPrint($scope.param).then((res) => {
                            layer.close(opening)
                            logger.logSuccess('开票开具成功，已提交打印!')
                            $scope.isCancelReopenInv && cancelRewrite(0)
                            $scope.goListPage()
                        }, (err) => {
                            $scope.isCancelReopenInv && cancelRewrite(1)
                            // 会写失败原因
                            // httpRequest.post_writeOvatInvoiceFailReason({
                            //     reason: err.retmsg,
                            //     waitId: $scope.param.waitId,
                            // }).then(() => {
                            //     $scope.param.isLock = '0'
                            // })
                            $scope.isRedInfo && httpRequest.post_reddingFailedBackWrite([$scope.param.waitId])
                            layer.close(opening)
                            logger.logError(err.retmsg)
                            // if (err.retcode == 5012) {
                            // $state.go('outputManage.FOManage.vehicleInvoice.list')
                            $scope.goListPage()
                            // }
                        })
                    }
                }
            }, (err) => {
                $scope.isCancelReopenInv && cancelRewrite(1)
                $scope.goListPage()
                logger.logError(err)
            })
        }

        // 价税合计小写大写联动
        $scope.lowerCaseIptBlur = function lowerCaseIptBlur() {
            // 是否正确的金额
            function isAmount(v) {
                if (v < 0) {
                    v = -1 * v
                }
                v = (v == +v) ? (+v).toFixed(2) : v
                const reg = /^\d{1,9}(\.\d{0,2})?$/ // 金额规则 数字，小数点前9位，后2位
                return reg.test(v)
            }
            if (!isAmount($scope.param.adValoremTotal)) {
                $scope.param.adValoremTotal = '0.00'
                logger.logError('价税合计输入金额不合法')
            } else {
                $scope.param.adValoremTotal = (+$scope.param.adValoremTotal).toFixed(2)
                $scope.adValoremTotalUpper = globalFn.digitUppercase(+$scope.param.adValoremTotal)
                $scope.param.totalAmt = (+$scope.param.adValoremTotal / (+$scope.param.taxRate + 1)).toFixed(2)
                $scope.param.totalTaxamt = ($scope.param.adValoremTotal - $scope.param.totalAmt).toFixed(2)
            }
        }
        // 吨位
        $scope.tonnageIptBlur = function tonnageIptBlur() {
            // 是否正确的数据
            function tonnageCheck(v) {
                v = (v == +v) ? (+v).toFixed(2) : v
                const reg = /^\d{1,5}(\.\d{0,2})?$/ // 8个字符，小数点前5位，后2位
                return reg.test(v)
            }
            if (!tonnageCheck($scope.param.vehicleInvoice.tonnage)) {
                $scope.param.vehicleInvoice.tonnage = ''
                logger.logError('吨位不符合规则，请重新输入')
            } else {
                $scope.param.vehicleInvoice.tonnage = (+$scope.param.vehicleInvoice.tonnage).toFixed(2)
            }
        }
        // 接口回值税率格式转换
        $scope.taxRateChange = function taxRateChange() {
            const {
                taxRateObj
            } = $scope.param
            $scope.carInfo.privilegeType = taxRateObj.privilegeType
            $scope.param.taxRate = taxRateObj.taxRate
            $scope.carInfo.taxRate = taxRateObj.taxRate
            $scope.carInfo.isPrivilege = taxRateObj.isPrivilege
        }
        $scope.$watch('param.custCreditCode', () => {
            $scope.param.custCreditCode = $scope.param.custCreditCode && $scope.param.custCreditCode.toUpperCase()
        })
        $scope.$watch('buyerInfo', (next, pre) => {
            // 限制因字符数招标的输入操作
            if (vehicle.lengthForString($scope.buyerInfo.customerName) > 72) {
                $scope.buyerInfo.customerName = $scope.buyerInfo.customerName.slice(0, pre.customerName.length)
            }
            if (vehicle.lengthForString($scope.buyerInfo.creditCode) > 20) {
                $scope.buyerInfo.creditCode = $scope.buyerInfo.creditCode.slice(0, pre.creditCode.length)
            }
            if (vehicle.lengthForString($scope.buyerInfo.certificateNo) > 22) {
                $scope.buyerInfo.certificateNo = $scope.buyerInfo.certificateNo.slice(0, pre.certificateNo.length)
            }
            $scope.param.custName = $scope.buyerInfo.customerName
            $scope.param.creditType = $scope.buyerInfo.taxplayerType
            $scope.param.custCreditCode = $scope.buyerInfo.creditCode
            $scope.param.custIdentifyNo = $scope.buyerInfo.certificateNo
        }, true)
        $scope.buyerInfoFun = function buyerInfoFun(item) {
            $scope.buyerInfo = {}
            $timeout(() => {
                $scope.buyerInfo = item
            })
        }
        $scope.carInfoFun = function carInfoFun(item) {
            console.log(item)
            $scope.carInfo = item
        }
        $scope.$watch('carInfo', (next, pre) => {
            // 限制因字符数超标的输入操作
            if (vehicle.lengthForString($scope.carInfo.vehicleType) > 40) {
                $scope.carInfo.vehicleType = $scope.carInfo.vehicleType.slice(0, pre.vehicleType.length)
            }
            if (vehicle.lengthForString($scope.carInfo.brandmode) > 60) {
                $scope.carInfo.brandmode = $scope.carInfo.brandmode.slice(0, pre.brandmode.length)
            }
            if (vehicle.lengthForString($scope.carInfo.place) > 32) {
                $scope.carInfo.place = $scope.carInfo.place.slice(0, pre.place.length)
            }
            // 生产企业名称
            if (vehicle.lengthForString($scope.carInfo.enterpriseName) > 80) {
                $scope.carInfo.enterpriseName = $scope.carInfo.enterpriseName.slice(0, pre.enterpriseName.length)
            }
            $scope.param.vehicleInvoice.vehicleType = $scope.carInfo.vehicleType
            $scope.param.vehicleInvoice.factoryModel = $scope.carInfo.brandmode
            $scope.param.vehicleInvoice.placeOfOrigin = $scope.carInfo.place
            $scope.param.vehicleInvoice.manufacturer = $scope.carInfo.enterpriseName
            $scope.param.vehicleInvoice.vehicleTypeCode = $scope.carInfo.code
            $scope.codeVersions = $scope.carInfo.codeVersions

            if (next.taxMergeCode) {
                const rateReq = {
                    taxMergeCode: next.taxMergeCode,
                    invType: '12',
                    privilegeType: encodeURIComponent(next.privilegeType),
                }
                httpRequest.get_queryGoodsTax(rateReq).then((res) => {
                    const taxRateArr = res.data.value
                    $scope.taxRateArr = res.data.value
                    for (let i = 0, {
                            length
                        } = taxRateArr; i < length; i++) {
                        const taxRateItem = taxRateArr[i]
                        if (taxRateItem.taxRate === next.taxRate &&
                            taxRateItem.privilegeType === next.privilegeType) {
                            next.taxRateObj = taxRateItem
                            $scope.param.taxRateObj = taxRateItem
                            break
                        }
                    }
                })
            }
            $scope.param.taxRate = $scope.carInfo.taxRate
        }, true)

        $scope.$watch('param', (next, pre) => {
            // 合格证号
            if (vehicle.lengthForString($scope.param.vehicleInvoice.certificateNumber) > 50) {
                $scope.param.vehicleInvoice.certificateNumber = $scope.param.vehicleInvoice.certificateNumber.slice(0, pre.vehicleInvoice.certificateNumber.length)
            }
            // 进口证明书号
            if (vehicle.lengthForString($scope.param.vehicleInvoice.importIdNumber) > 36) {
                $scope.param.vehicleInvoice.importIdNumber = $scope.param.vehicleInvoice.importIdNumber.slice(0, pre.vehicleInvoice.importIdNumber.length)
            }
            // 商检单号
            if (vehicle.lengthForString($scope.param.vehicleInvoice.checkNumber) > 32) {
                $scope.param.vehicleInvoice.checkNumber = $scope.param.vehicleInvoice.checkNumber.slice(0, pre.vehicleInvoice.checkNumber.length)
            }
            // 发动机号码
            if (vehicle.lengthForString($scope.param.vehicleInvoice.engineNumber) > 50) {
                $scope.param.vehicleInvoice.engineNumber = $scope.param.vehicleInvoice.engineNumber.slice(0, pre.vehicleInvoice.engineNumber.length)
            }
            // 车辆识别代号/车架号码
            if (vehicle.lengthForString($scope.param.vehicleInvoice.vehicleNumber) > 23) {
                $scope.param.vehicleInvoice.vehicleNumber = $scope.param.vehicleInvoice.vehicleNumber.slice(0, pre.vehicleInvoice.vehicleNumber.length)
            }
            // 吨位
            if (vehicle.lengthForString($scope.param.vehicleInvoice.tonnage) > 8) {
                $scope.param.vehicleInvoice.tonnage = $scope.param.vehicleInvoice.tonnage.slice(0, pre.vehicleInvoice.tonnage.length)
            }
            // 限乘人数
            if (vehicle.lengthForString($scope.param.vehicleInvoice.limitPeople) > 12) {
                $scope.param.vehicleInvoice.limitPeople = $scope.param.vehicleInvoice.limitPeople.slice(0, pre.vehicleInvoice.limitPeople.length)
            }
            // 小写
            if (vehicle.lengthForString(`${$scope.param.adValoremTotal}`) > 12) {
                $scope.param.adValoremTotal = $scope.param.adValoremTotal.slice(0, pre.adValoremTotal.length)
            }

            // 电话
            if (vehicle.lengthForString($scope.param.salePhone) > 40) {
                $scope.param.salePhone = $scope.param.salePhone.slice(0, pre.salePhone.length)
            }

            // 账号
            if (vehicle.lengthForString($scope.param.saleBankAccount) > 40) {
                $scope.param.saleBankAccount = $scope.param.saleBankAccount.slice(0, pre.saleBankAccount.length)
            }

            // 地址
            if (vehicle.lengthForString($scope.param.saleAddress) > 80) {
                $scope.param.saleAddress = $scope.param.saleAddress.slice(0, pre.saleAddress.length)
            }

            // 开户银行
            if (vehicle.lengthForString($scope.param.saleBank) > 80) {
                $scope.param.saleBank = $scope.param.saleBank.slice(0, pre.saleBank.length)
            }

            if ($scope.redVehicleInv) {
                $scope.param.adValoremTotal = $scope.param.adValoremTotal > 0 ? (-1 * $scope.param.adValoremTotal) : $scope.param.adValoremTotal
            }
            if (next.taxRate !== pre.taxRate) {
                $scope.param.totalAmt = (+$scope.param.adValoremTotal / (+$scope.param.taxRate + 1)).toFixed(2)
                $scope.param.totalTaxamt = ($scope.param.adValoremTotal - $scope.param.totalAmt).toFixed(2)
            }

            $scope.param.isTax = $scope.carInfo.isPrivilege == 1 ? '0' : '1'
            if ($scope.carInfo.taxMergeCode) {
                $scope.param.waitDetailList[0].adValoremTotal = $scope.param.adValoremTotal
                $scope.param.waitDetailList[0].amount = $scope.param.totalAmt
                $scope.param.waitDetailList[0].invoiceId = $scope.param.waitId
                $scope.param.waitDetailList[0].isPrivilege = $scope.carInfo.isPrivilege
                $scope.param.waitDetailList[0].isTax = $scope.param.isTax
                $scope.param.waitDetailList[0].matCode = $scope.param.vehicleInvoice.vehicleTypeCode
                $scope.param.waitDetailList[0].matName = $scope.carInfo.vehicleType
                $scope.param.waitDetailList[0].price = Math.abs($scope.param.totalAmt)
                $scope.param.waitDetailList[0].privilegeType = $scope.carInfo.privilegeType
                $scope.param.waitDetailList[0].quantity = $scope.redVehicleInv ? -1 : 1
                $scope.param.waitDetailList[0].revenueCode = $scope.carInfo.taxMergeCode
                $scope.param.waitDetailList[0].revenueName = $scope.carInfo.taxClassName
                $scope.param.waitDetailList[0].revenueVersion = $scope.carInfo.codeVersions
                $scope.param.waitDetailList[0].shortAndMatName = $scope.carInfo.vehicleType
                $scope.param.waitDetailList[0].taxAmount = $scope.param.totalTaxamt
                $scope.param.waitDetailList[0].taxPrice = Math.abs($scope.param.totalTaxamt)
                $scope.param.waitDetailList[0].taxRate = Math.abs($scope.param.taxRate)
            }
        }, true)

        function cancelRewrite(reopenRet) {
            httpRequest.post_writeBackReopenInvoice({
                invoiceId: $scope.canceledInvoiceId,
                reopenRet,
                waitId: $scope.param.waitId
            })
        }
    }
}
VehicleInvAddCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', 'sweetalert', 'globalFn', '$state', '$timeout', 'invoiceOpenService', 'operationService', 'buyerChecker']


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/vehicleInvoice/add.js